import { render } from "./AsInput.vue?vue&type=template&id=6dff7552&scoped=true"
import script from "./AsInput.vue?vue&type=script&lang=js"
export * from "./AsInput.vue?vue&type=script&lang=js"

import "./AsInput.vue?vue&type=style&index=0&id=6dff7552&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dff7552"]])

export default __exports__